import { VALIDATION_ICON_MAP } from "./chunk-REF6H5TE.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Validation/ValidationIcon.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var VALIDATION_ICON_CLASSNAME_MAP = {
  variant: {
    success: "pd:text-success-600",
    info: "pd:text-info-600",
    warning: "pd:text-warning-600",
    error: "pd:text-error-600",
    dim: "pd:text-dim-800"
  }
};
var ValidationIcon = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      variant = "info",
      className
    } = _b,
    rest = __objRest(_b, ["children", "variant", "className"]);
  return /* @__PURE__ */jsx(Icon_default, __spreadValues({
    ref,
    icon: VALIDATION_ICON_MAP[variant],
    className: clsx("pd:validation-icon", VALIDATION_ICON_CLASSNAME_MAP.variant[variant], className)
  }, rest));
});
var ValidationIcon_default = ValidationIcon;
export { VALIDATION_ICON_CLASSNAME_MAP, ValidationIcon_default };